export const poseInstructions = {
  "Tadasana": [
    "Stand straight with your feet together",
    "Keep your spine tall and shoulders relaxed",
    "Interlock your fingers and raise your arms overhead",
    "Look forward and stretch your entire body upward",
    "Hold the pose while breathing normally"
  ],
  "Padmasana": [
    "Sit comfortably on the floor with legs extended",
    "Bend your right knee and place your right foot on your left thigh",
    "Bend your left knee and place your left foot on your right thigh",
    "Keep your spine straight and shoulders relaxed",
    "Rest your hands on your knees in Gyan Mudra",
    "Breathe deeply and hold the pose"
  ],
  "Vrksasana": [
    "Stand straight in Tadasana",
    "Shift your weight onto your left leg",
    "Place your right foot on the inner left thigh",
    "Bring your palms together in front of your chest",
    "Raise your arms overhead and focus on a point",
    "Hold and breathe steadily"
  ],
  "Adho Mukha Svanasana": [
    "Start on all fours in tabletop position",
    "Tuck your toes and lift your hips up and back",
    "Straighten your legs and arms as much as possible",
    "Press your chest toward your thighs",
    "Keep your head relaxed and gaze toward your feet",
    "Hold and breathe deeply"
  ],
  "Bhujangasana": [
    "Lie down on your stomach with palms under shoulders",
    "Inhale and lift your chest off the floor",
    "Keep your elbows slightly bent",
    "Look forward or slightly upward",
    "Press your pubic bone into the floor",
    "Hold the pose while breathing"
  ],
  "Paschimottanasana": [
    "Sit with your legs stretched straight in front",
    "Inhale and raise your arms overhead",
    "Exhale and bend forward from your hips",
    "Try to reach your toes with your hands",
    "Keep your spine long and breathe deeply"
  ],
  "Balasana": [
    "Kneel on the floor and sit back on your heels",
    "Fold forward and rest your forehead on the mat",
    "Extend your arms forward or place them beside your body",
    "Relax your shoulders and breathe deeply",
    "Stay in child's pose as long as comfortable"
  ],
  "Savasana": [
    "Lie down flat on your back",
    "Keep your legs slightly apart and arms away from body",
    "Palms facing upward and eyes closed",
    "Relax your entire body completely",
    "Breathe slowly and deeply"
  ],
  "Virabhadrasana II": [
    "Stand with your feet wide apart",
    "Turn your right foot outward 90 degrees",
    "Bend your right knee until your thigh is parallel to the floor",
    "Stretch your arms out to the sides",
    "Look over your right hand",
    "Hold and breathe"
  ],
  "Utkatasana": [
    "Stand straight with feet together",
    "Inhale and raise your arms overhead",
    "Exhale and bend your knees as if sitting in a chair",
    "Keep your spine straight and chest lifted",
    "Hold the pose while breathing steadily"
  ]
};

export const getInstructionsForPose = (poseName) => {
  return poseInstructions[poseName] || [
    "Assume the starting position",
    "Move slowly into the full pose",
    "Hold steadily and breathe deeply",
    "Maintain good alignment",
    "Release the pose gently when done"
  ];
};